"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SDK_INTERSTITIAL_V1 = exports.SDK_INTERSTITIAL = void 0;
exports.SDK_INTERSTITIAL = {
    BODY: 'With Flexible Rent, you can split your rent into two smaller payments using a Flex line of credit.',
    CTA: 'See your new options',
    HEADER: 'Pay part now, the rest later',
    LIST: {
        HEADER: 'Flexible Rent helps you',
        ITEM_1: 'Pay rent on time',
        ITEM_2: 'Improve your cash flow',
        ITEM_3: 'Build your credit history with rent reporting'
    },
    NOTICE_1: 'By continuing, you agree to Flex’s ',
    NOTICE_2: '. Flex line of credit is issued by Lead Bank. Visit ',
    NOTICE_3: ' for more info.',
    SUB_HEADER: ''
};
exports.SDK_INTERSTITIAL_V1 = __assign(__assign({}, exports.SDK_INTERSTITIAL), { LIST: {
        HEADER: 'How Flex works',
        ITEM_1: 'You’ll pay part of your rent to Flex when your rent is due',
        ITEM_2: 'Then we’ll help pay your full rent to your property',
        ITEM_3: 'You’ll then pay the other part of your rent to Flex later'
    }, SUB_HEADER: 'Join 1 million residents who have paid rent with Flex' });
